import { jobLists } from "character";
import JobIcon from "components/job-icon/JobIcon";
import Link from "components/link/Link";
import NoCharacter from "components/no-character/NoCharacter";
import RelicCheckbox from "components/relic-checkbox/RelicCheckbox";
import { quests } from "data-files/quests";
import { EorzeaDataType, GameData, Job, LinkType, RelicData, View } from "enums";
import manager from "managers/app";
import { ViewRelicInfo } from "managers/types/relic-types";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import ContentHeader from "views/page-parts/content/content-header/ContentHeader";
import DetailsSection from "views/page-parts/content/details-section/DetailsSection";
import OverviewTable from "views/page-parts/content/overview-table/OverviewTable";
import { Requirement } from "views/page-parts/content/relic-requirements/types";
import { ViewToolLucisMastercraftProps } from "views/relics/tools/lucis/mastercraft/types";
import "./ToolLucisMastercraft.css";

const mapStateToProps = (state:AppState) => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		userInfo: state.userInfo,
		hideCompletedSteps: state.userInfo.options.hideCompletedSteps,
		hideCompletedTasks: state.userInfo.options.hideCompletedTasks,
		showJob: state.userInfo.options.job,
	};
};

class ToolLucisMastercraft extends Component<ViewToolLucisMastercraftProps> {
	private requirements:Requirement[] = [];
	private importantNPCs:GameData.NPC[] = [];
	private relicInfo:ViewRelicInfo = {
		jobs: jobLists.relic[RelicData.Group.TOOL_LUCIS],
		type: RelicData.Type.TOOL,
		relic: RelicData.Group.TOOL_LUCIS,
		part: RelicData.Part.TOOL_MASTERCRAFT,
		steps: [RelicData.Step.CLASS_QUESTS],
		stepPlaceholders: {},
		next: {
			part: RelicData.Part.TOOL_SUPRA,
			view: View.RELIC_TOOLS_LUCIS_SUPRA,
		},
		previous: null,
	};

	constructor(props:ViewToolLucisMastercraftProps){
		super(props);
		this.requirements = this.getRequirements();
		this.importantNPCs = this.getImportantNPCs();
	}

	render():JSX.Element{
		const character = manager.data.getActiveCharacter();
		if(character === null){ return <NoCharacter />; }

		const completeSteps = manager.content.getCompleteSteps(character.progress, this.relicInfo);

		const tableRows = [
			{ job: Job.CRP, quest: GameData.Quest.SAVING_CAPTAIN_GAIRHARD },
			{ job: Job.BSM, quest: GameData.Quest.WAITING_IN_THE_WINGLET },
			{ job: Job.ARM, quest: GameData.Quest.RIVALRY_AND_RESPECT },
			{ job: Job.GSM, quest: GameData.Quest.JADED },
			{ job: Job.LTW, quest: GameData.Quest.ACCEPT_NO_IMITATIONS },
			{ job: Job.WVR, quest: GameData.Quest.A_MINER_REBORN },
			{ job: Job.ALC, quest: GameData.Quest.MOMENTARY_MIRACLE },
			{ job: Job.CUL, quest: GameData.Quest.REVENGE_OF_THE_CHEFSBANE },
			{ job: Job.MIN, quest: GameData.Quest.CANYON_OF_REGRET },
			{ job: Job.BTN, quest: GameData.Quest.SEEDS_OF_HOPE },
			{ job: Job.FSH, quest: GameData.Quest.SO_LONG_THANKS_FOR_ALL_THE_FISH },
		];

		return (
			<div id="tool-lucis-mastercraft" className="relic">
				<ContentHeader requirements={this.requirements} importantNPCs={this.importantNPCs} relicInfo={this.relicInfo}>
				</ContentHeader>
				<div id="relic-checklist">
					<OverviewTable character={character} completeSteps={completeSteps} relicInfo={this.relicInfo} />
				</div>
				<div id="relic-details">
					<h1>{t.t("Details")}</h1>
					{this.props.hideCompletedSteps && completeSteps.allComplete ? t.t("All Steps Complete") : null }
					<DetailsSection title={RelicData.Step.CLASS_QUESTS} id={RelicData.Step.CLASS_QUESTS} stepComplete={completeSteps[RelicData.Step.CLASS_QUESTS]}>
						<p>{t.t("Complete level 50 job quest")}</p>
						<div className="table-wrapper">
							<table className="table">
								<thead><tr><th>{t.t("Job")}</th><th>{t.t("Quest")}</th><th>{t.t("Done")}</th></tr></thead>
								<tbody>
									{tableRows.map((row) => {
										const relicName = manager.relics.getRelicNameKey(row.job, RelicData.Part.TOOL_MASTERCRAFT);

										return <tr key={`masterwork-${row.job}`}>
											<td><JobIcon job={row.job} tooltip={relicName} /></td>
											<td><Link type={LinkType.LODESTONE} lodestoneType={EorzeaDataType.BLUEQUEST} text={row.quest} lodestoneID={quests[row.quest].lodestoneID} /></td>
											<td><RelicCheckbox character={character} job={row.job} relicInfo={this.relicInfo} step={RelicData.Step.CLASS_QUESTS} /></td>
										</tr>;
									})}
								</tbody>
							</table>
						</div>
					</DetailsSection>
				</div>
			</div>
		);
	}

	componentDidMount(){
		manager.view.changeComplete();
	}

	private getRequirements():Requirement[]{
		return [];
	}

	private getImportantNPCs():GameData.NPC[]{
		return [];
	}
}
export default connect(mapStateToProps)(ToolLucisMastercraft);
